const isLoading = (state) => state.loading > 0

export default {
  isLoading
}
